"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _reactTransitionGroup = require("react-transition-group");

var _options = _interopRequireDefault(require("../dropdown/options"));

var _es6PromiseDebounce = _interopRequireDefault(require("es6-promise-debounce"));

var _input = _interopRequireDefault(require("../input"));

var _icon = _interopRequireDefault(require("../icon"));

var _loader = _interopRequireDefault(require("../loader"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var _ref = /*#__PURE__*/_jsx(_loader["default"], {
  size: "sm"
});

var InputSearch = /*#__PURE__*/function (_PureComponent) {
  _inherits(InputSearch, _PureComponent);

  var _super = _createSuper(InputSearch);

  function InputSearch() {
    var _this;

    _classCallCheck(this, InputSearch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      fetchingCount: 0,
      focused: false,
      result: []
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      return _this.setState({
        focused: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      return setTimeout(function () {
        return _this.setState({
          focused: false
        });
      }, 100);
    });

    _defineProperty(_assertThisInitialized(_this), "incrementFetching", function () {
      return _this.setState({
        fetchingCount: _this.state.fetchingCount + 1
      });
    });

    _defineProperty(_assertThisInitialized(_this), "decrementFetching", function () {
      return _this.setState({
        fetchingCount: _this.state.fetchingCount - 1
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequest", (0, _es6PromiseDebounce["default"])(function (value) {
      _this.incrementFetching();

      _this.props.request(value).then(function (response) {
        _this.decrementFetching();

        return _this.setState({
          result: response.data.map(_this.props.mapResult)
        });
      })["catch"](function (error) {
        _this.decrementFetching();

        return Promise.reject({
          _error: error
        });
      });
    }, _this.props.delay));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      if (value) {
        _this.handleRequest(value);
      }

      return _this.props.input.onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClear", function () {
      _this.setState({
        fetchingCount: 0,
        focused: false,
        result: []
      });

      return _this.props.input.onChange(null);
    });

    return _this;
  }

  _createClass(InputSearch, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var allowedProps = _objectSpread({}, this.props);

      delete allowedProps.request;
      delete allowedProps.mapResult;
      delete allowedProps.delay;
      var showOptions = this.state.focused && allowedProps.input.value && !!this.state.result.length;
      return /*#__PURE__*/_jsx("div", {
        className: cx('xsui-input__mod-search')
      }, void 0, /*#__PURE__*/_react["default"].createElement(_input["default"], _extends({}, allowedProps, {
        input: _objectSpread(_objectSpread({}, allowedProps.input), {}, {
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          onChange: function onChange(e) {
            return _this2.handleChange(e.target.value);
          }
        }),
        autoComplete: "off",
        offset: !!this.state.fetchingCount || allowedProps.input.value ? 'both' : 'left',
        icon: "search",
        extra: /*#__PURE__*/_jsx(_react.Fragment, {}, void 0, this.state.fetchingCount ? _ref : allowedProps.input.value && /*#__PURE__*/_jsx(_icon["default"], {
          name: "circle-remove-mini",
          hoverable: true,
          onClick: this.handleClear
        }))
      })), /*#__PURE__*/_jsx(_reactTransitionGroup.TransitionGroup, {}, void 0, showOptions && /*#__PURE__*/_jsx(_reactTransitionGroup.CSSTransition, {
        classNames: "slide-transition",
        timeout: 200
      }, void 0, /*#__PURE__*/_jsx(_options["default"], {
        appearance: "tertiary",
        size: "sm",
        items: this.state.result,
        value: allowedProps.input.value,
        onChange: function onChange(value) {
          return allowedProps.input.onChange(value);
        }
      }))));
    }
  }]);

  return InputSearch;
}(_react.PureComponent);

_defineProperty(InputSearch, "defaultProps", {
  mapResult: function mapResult(a) {
    return a;
  },
  delay: 250
});

var _default = InputSearch;
exports["default"] = _default;